import { VStack, Divider, Box, Spinner, Text, cssVar } from '@cad-arc';
import { FC } from 'react';
import { observer } from 'mobx-react';
import { RelatedDataEntity } from '@mark43/cad-api';
import { intersperse } from '../../../common/helpers/intersperse';

export const RelatedDataEntityRows = observer(
    ({
        entities,
        hasMoreRows,
        noEntitiesText,
        RowComponent,
        onViewMore,
        isLoading,
    }: {
        entities: RelatedDataEntity[];
        hasMoreRows: boolean;
        noEntitiesText: string;
        RowComponent: FC<{ entity: RelatedDataEntity }>;
        onViewMore: () => void;
        isLoading: boolean;
    }) => {
        return (
            <VStack marginTop="2" align="start">
                {entities.length === 0 && (
                    <Box marginLeft="2">
                        <Text variant="bodyMd" color="tertiary">
                            {noEntitiesText}
                        </Text>
                    </Box>
                )}
                {entities.length > 0 &&
                    intersperse(
                        entities.map((entity) => (
                            <RowComponent key={entity.entityId} entity={entity} />
                        )),
                        <Divider />
                    )}
                {hasMoreRows && (
                    <Box width="100%">
                        <Text
                            data-testid="VIEW_MORE_BUTTON"
                            variant="bodyMd"
                            fontWeight="bold"
                            style={{
                                color: cssVar('arc.colors.brand.default'),
                                cursor: 'pointer',
                            }}
                            align="center"
                            onClick={() => {
                                if (!isLoading) {
                                    onViewMore();
                                }
                            }}
                        >
                            {!isLoading && 'View More'}
                            {isLoading && <Spinner size="sm" />}
                        </Text>
                    </Box>
                )}
            </VStack>
        );
    }
);
